import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n\tfont-size: 0.9em; /* makes unicode icon smaller, doesn't touch svg icon */\n\tline-height: 0;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tbackground: none;\n\tborder: none;\n\tpadding: inherit;\n\tappearance: none;\n\tfont-weight: inherit;\n\t", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n\t", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n\t\t\tpadding-bottom: 2px;\n\t\t\tborder-bottom: 1px solid currentColor;\n\t\t"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n\t\t\talign-items: center;\n\t\t\tline-height: normal;\n\t\t"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n\t\t\t\t\t:hover,\n\t\t\t\t\t:focus {\n\t\t\t\t\t\tborder-bottom-color: ", ";\n\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t}\n\t\t\t\t\t:focus {\n\t\t\t\t\t\t", "\n\t\t\t\t\t}\n\t\t\t  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\t\t\t\t\tpointer-events: none;\n\t\t\t  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tposition: relative;\n\tcolor: ", ";\n\ttext-decoration: none;\n\n\t", "\n\n\t", "\n\n\t", ";"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { css } from 'styled-components';
import { styled } from '../theme-provider';
import { createA11yOutlineStyles } from '../helpers';
var linkBaseStyles = css(_templateObject(), function (props) {
  return props.disabled ? props.theme.interaction.recipe400.disabled : props.theme.interaction.recipe400.default;
}, function (props) {
  return props.disabled ? css(_templateObject2()) : css(_templateObject3(), props.theme.interaction.recipe400.hover, props.theme.interaction.recipe400.hover, createA11yOutlineStyles(props));
}, function (props) {
  return (props.iconRight || props.iconLeft) && css(_templateObject4());
}, function (props) {
  return props.isInline && css(_templateObject5());
});
var StyledLink = styled.a.withConfig({
  displayName: "StyledLink",
  componentId: "sc-jijr17"
})(_templateObject6(), linkBaseStyles);
var StyledLinkButton = styled.button.withConfig({
  displayName: "StyledLinkButton",
  componentId: "sc-mr76mu"
})(_templateObject7(), linkBaseStyles);
var StyledIconWrapper = styled.span.withConfig({
  displayName: "StyledIconWrapper",
  componentId: "sc-1j121q"
})(_templateObject8());
export var Link = function Link(props) {
  var children = props.children,
      href = props.href,
      onClick = props.onClick,
      onMouseOut = props.onMouseOut,
      onMouseOver = props.onMouseOver,
      rel = props.rel,
      target = props.target,
      innerRef = props.innerRef,
      isInline = props.isInline,
      title = props.title,
      iconLeft = props.iconLeft,
      iconRight = props.iconRight,
      property = props.property,
      typeOf = props.typeOf,
      disabled = props.disabled;
  return React.createElement(StyledLink, {
    ref: innerRef,
    isInline: isInline,
    iconLeft: iconLeft,
    iconRight: iconRight,
    href: !disabled && href || undefined,
    onClick: !disabled && onClick || undefined,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    target: target,
    rel: rel,
    title: title,
    property: property,
    typeOf: typeOf,
    disabled: disabled
  }, iconLeft && React.createElement(React.Fragment, null, React.createElement(StyledIconWrapper, null, iconLeft), ' '), children, iconRight && React.createElement(React.Fragment, null, ' ', React.createElement(StyledIconWrapper, null, iconRight)));
};
export var LinkButton = function LinkButton(props) {
  var children = props.children,
      onClick = props.onClick,
      innerRef = props.innerRef,
      isInline = props.isInline,
      iconLeft = props.iconLeft,
      iconRight = props.iconRight,
      disabled = props.disabled;
  return React.createElement(StyledLinkButton, {
    ref: innerRef,
    isInline: isInline,
    iconLeft: iconLeft,
    iconRight: iconRight,
    onClick: !disabled && onClick || undefined,
    disabled: disabled
  }, iconLeft && React.createElement(React.Fragment, null, React.createElement(StyledIconWrapper, null, iconLeft), ' '), children, iconRight && React.createElement(React.Fragment, null, ' ', React.createElement(StyledIconWrapper, null, iconRight)));
};